import './Loading.scss'


export default function Loading() {
    return (
        <div className="loading">
            <div className="main_loader">
                <div className="loader"></div>
            </div>
        </div>
    )
}